import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-interdepartment-trading-form',
    templateUrl: './interdepartment-trading-form.component.html',
})
export class InterdepartmentTradingFormComponent {
    @Input({ required: true }) form!: FormGroup;

    buyerAndSellerTypes = ['A-deild', 'B-deild', 'Verðbréfaleið', 'Innlánaleið'];
}
